import axios from "axios";
import { UserStore, GlobalStore } from "stores";
import type {
  FntClaimInfoRes,
  FntClaimScheduleRes,
  ClaimFntTokenReq,
} from "./types/fntClaim";

export const getFntClaimInfo = async () =>
  axios
    .get<FntClaimInfoRes>("/fnt-token-claim")
    .then(({ data }) => UserStore.setClaimInfo(data.claimInfo))
    .catch((err) => {
      if (err?.response?.data?.message) {
        GlobalStore.setError(err.response.data.message);
      }
    });

export const getFntClaimSchedule = async () =>
  axios.get<FntClaimScheduleRes>(`/fnt-token-claim/schedule/list`);

export const claimFntToken = async (reqData: ClaimFntTokenReq) =>
  axios.post<boolean>("/fnt-token-claim", reqData);
